/**
 * Page to show customer tasks
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

import AbEnvironment from '../auth/AbEnvironment';
import TaskList from './TaskList';

import PageTitle from '../ui/PageTitle';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    // color: theme.palette.text.secondary,
    maxWidth: 1200,
    marginTop: 16,
  }
});

class CustomerTasks extends Component {

    render() {
        const { isUnauthenticatedCustomer } = this.props.auth;
        const classes = this.props.classes;
  
        if (!isUnauthenticatedCustomer()) {
            return (
                <Redirect to='/home' />
            );
        } else {
            let title = "My tasks";
            let subTitle = "Todos to get my project moving";
            let acctId = abEnvironment.getUserAttribute("a_id");

            let showMainTitle = false;

            if (showMainTitle) {
                return (
                    <React.Fragment>
                        <PageTitle title={title} subtitle={subTitle}/>
                        {/* <PageTitle title={title}/> */}
                        <Paper className={classes.paper}>
                            <TaskList parentMainTitle={showMainTitle} accountId={acctId} auth={this.props.auth} history={this.props.history}/>
                        </Paper>
                    </React.Fragment>
                );
            }

            return (
                <React.Fragment>
                    <TaskList parentMainTitle={showMainTitle} accountId={acctId} auth={this.props.auth} history={this.props.history}/>
                </React.Fragment>
            );
        }
    }
}
  
CustomerTasks.propTypes = {
    classes: PropTypes.object.isRequired,
};
      
export default withStyles(styleSheet)(CustomerTasks);
  